import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatTimestamp } from "../../../utils/helper";
import { getPlaAuditHistoryService } from "../../../core/services/plaFeedServices";
import PlaFeedAuditLog, { summarizePlaLog, timeAgo } from "./PlaFeedAuditLog";

const PlaFeedListItem = (props: any) => {
  const navigate = useNavigate();
  const { data } = props;

  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});
  const [auditData, setAuditData] = useState<Record<string, any[]>>({});
  const [loadingRows, setLoadingRows] = useState<Record<string, boolean>>({});

  const updatePlaFeedNavigateHandler = (uid: any) => {
    navigate(`/plaFeed/${uid}`);
  };

  const toggleRow = (msn: string) => {
    if (!msn) return;
    const isCurrentlyExpanded = !!expandedRows[msn];
    const nextExpanded = !isCurrentlyExpanded;

    setExpandedRows((prev) => ({ ...prev, [msn]: nextExpanded }));

    // Fetch on demand if not already loaded or loading
    if (nextExpanded && !auditData[msn] && !loadingRows[msn]) {
      setLoadingRows((prev) => ({ ...prev, [msn]: true }));
      getPlaAuditHistoryService(msn)
        .then((response: any) => {
          const logs = response?.data?.data || [];
          setAuditData((prev) => ({ ...prev, [msn]: logs }));
        })
        .catch((err: any) => {
          console.error("Failed to fetch PLA audit history for " + msn, err);
          setAuditData((prev) => ({ ...prev, [msn]: [] }));
        })
        .finally(() => {
          setLoadingRows((prev) => ({ ...prev, [msn]: false }));
        });
    }
  };

  return (
    <>
      {data.map((item: any, index: number) => {
        const msn = item?.id || "";
        const isExpanded = !!expandedRows[msn];
        const logs = auditData[msn];
        const isLoading = !!loadingRows[msn];

        const latestLog = logs && logs.length > 0 ? logs[0] : null;

        return (
          <React.Fragment key={item?.uid || item?.id || index}>
            <tr className="[&:nth-child(odd)]:bg-[#f7f7f7]">
              <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[12%] font-medium">
                {item?.id}
              </td>
              <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[16%]">
                {item?.customLabel0}
              </td>
              <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[14%]">
                {item?.productType}
              </td>
              <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[11%]">
                {item.countryCode === "356" ? "India" : item.countryCode === "784" ? "UAE" : item.countryCode}
              </td>
              <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[10%]">
                {item?.availability}
              </td>
              <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[8%]">
                {item.shoppingAds ? (
                  <span className="inline-block px-1.5 py-0.5 rounded text-[11px] font-medium bg-green-100 text-green-800 border border-green-200">
                    True
                  </span>
                ) : (
                  <span className="inline-block px-1.5 py-0.5 rounded text-[11px] font-medium bg-red-100 text-red-800 border border-red-200">
                    False
                  </span>
                )}
              </td>
              <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[11%]">
                {formatTimestamp(item?.modifiedAt)}
              </td>
              <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] w-[11%]">
                <button
                  type="button"
                  onClick={() => toggleRow(msn)}
                  className="text-left group flex flex-col items-start outline-none cursor-pointer"
                  title="View change history"
                >
                  <span className="flex items-center gap-1.5">
                    {logs && logs.length > 0 ? (
                      <span className="px-2 py-0.5 rounded-full bg-[#43425D] text-white text-[10px] font-semibold">
                        {logs.length} {logs.length === 1 ? "change" : "changes"}
                      </span>
                    ) : null}
                    <span className="text-[11px] text-blue-600 font-medium group-hover:underline">
                      {isExpanded ? "Hide" : "View History"}
                    </span>
                  </span>
                  {latestLog ? (
                    <span
                      className="block text-[10px] text-gray-500 mt-0.5 truncate max-w-[170px]"
                      title={`${summarizePlaLog(latestLog)} by ${latestLog.changedBy || "System"}`}
                    >
                      {summarizePlaLog(latestLog)} · {timeAgo(latestLog.historyTimestamp)}
                    </span>
                  ) : null}
                </button>
              </td>
              <td
                onClick={() => updatePlaFeedNavigateHandler(item.uid)}
                className="px-4 py-3 text-left text-xs text-[#337ab7] w-[7%] font-semibold cursor-pointer hover:underline"
              >
                Update
              </td>
            </tr>
            {isExpanded && (
              <tr className="bg-[#fbfbfb]">
                <td colSpan={9} className="px-8 py-2 border-b border-gray-200">
                  <PlaFeedAuditLog
                    logs={logs}
                    isLoading={isLoading}
                    msn={msn}
                  />
                </td>
              </tr>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};
export default PlaFeedListItem;
